import { memo, useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { TooltipItem } from "chart.js";
import { ICostByOperator } from "../../../interfaces/dashboard";
import {
  formatCurrency,
  formatCarrierName,
  currencyCodeFor,
} from "../../../utils/metricsFormatters";
import ChartContainer from "../ChartContainer";
import "../chartSetup";

// El costo es un dato neutral (no positivo ni negativo): barras siempre en azul,
// sin resaltar en rojo por umbral.
const BAR_COLOR = "#1976d2";

// Opciones dependientes del país (moneda de los ticks/tooltip).
const buildOptions = (country?: string) => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: (ctx: TooltipItem<"bar">) =>
          formatCurrency(ctx.parsed.y, country),
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: (value: number | string) =>
          formatCurrency(Number(value), country),
      },
    },
  },
});

interface ICostByOperatorProps {
  data: ICostByOperator[];
  // País activo (interno): moneda de las barras/ejes.
  country?: string;
}

const CostByOperator = ({ data, country }: ICostByOperatorProps) => {
  const options = useMemo(() => buildOptions(country), [country]);
  const chartData = useMemo(
    () => ({
      labels: data.map((d) => formatCarrierName(d.carrier_name, d.carrier_id)),
      datasets: [
        {
          label: `Costo promedio (${currencyCodeFor(country)})`,
          data: data.map((d) => d.avgCost),
          backgroundColor: BAR_COLOR,
          borderRadius: 4,
        },
      ],
    }),
    [data, country],
  );

  return (
    <ChartContainer>
      <Bar data={chartData} options={options} />
    </ChartContainer>
  );
};

export default memo(CostByOperator);
